import React, { useState } from 'react';
import InputMask from 'react-input-mask';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Conexao from '../Config/conexao';
import axios from 'axios';
import Menu from '../../site/Components/Menu/menu';
export default function AberturaTickt() {
    const [isOutrosChecked, setOutrosChecked] = useState(false);
    const [dataEnvio, setDataEnvio] = useState("");
    const [usuarioLogin, setUsuarioLogin] = useState("");
    const [email, setEmail] = useState("");
    const [contato, setContato] = useState("");
    const [telefone, setTelefone] = useState('');
    const [projeto, setProjeto] = useState("");
    const [problemaApresentado, setProblemaApresentado] = useState("");
    const [detalhes, setDetalhes] = useState("");
    const [itensEnviados, setItensEnviados] = useState();
    const [tag, setTag] = useState("");
    const [pc, setPc] = useState(false);
    const [carregador, setCarregador] = useState(false);
    const [outros, setOutros] = useState(false);
    const handleCheckboxChange = (event) => {
        setItensEnviados({
            ...itensEnviados,
            [event.target.id]: event.target.checked,
        });
    };
    const [emailError, setEmailError] = useState('');
    const handleEmailChange = (e) => {
        setEmail(e.target.value);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(e.target.value)) {
            setEmailError('Por favor, insira um email válido.');
        } else {
            setEmailError('');
        }
    };
    const [isProjetoEmpty, setIsProjetoEmpty] = useState(false);

    const handleProjetoChange = (event) => {
        setProjeto(event.target.value);
        setIsProjetoEmpty(!event.target.value);
    };

    function handleSubmit() {


        // Verifique se cada campo tem um valor. Se não tiver, defina uma mensagem de erro.
        if (!dataEnvio) {
            alert('Por favor, insira a data de envio.');
            return;
        }
        else if (!usuarioLogin) {
            alert('Por favor, insira o usuário de login.');
            return;
        }
        else if (!email) {
            alert('Por favor, insira o email.');
            return;
        }
        else if (!telefone) {
            alert('Por favor, insira o telefone.');
            return;
        }
        else if (!projeto) {
            alert('Por favor, insira o projeto.');
            return;
        }else{
            add()
        }

        // Se todos os campos tiverem um valor, continue com o envio do formulário.
        // ...
    };
    async function add() {
        
        // const obj = {
        //     dataEnvio: dataEnvio,
        //     usuarioLogin: usuarioLogin,
        //     email: email,
        //     contato: telefone,
        //     projeto: projeto,
        //     tag: tag,
        //     pc: pc,
        //     carregador: carregador,
        //     outros: outros,
        //     problemaApresentado: problemaApresentado,
        //     detalhes: detalhes
        // };

        // try {
        //     console.log(obj);
        //     const res = await axios.post(Conexao.api + 'InsertRegistroTicket.php', obj);

        //     if (res.data.success === true) {
        //     }
        // } catch (error) {
        //     // Tratar erros caso ocorram durante a requisição
        //     console.error('Erro ao tentar adicionar:', error);
        // }

        EnviarEmail() 
    }


    const [nticket, setNTicket] = useState();

    async function EnviarEmail() {

        // const setorX = ('SGI');

         const res2 = await axios.get(Conexao.api + 'BuscarNumeroTicket.php');
         setNTicket(res2.data.pegaProtocolo);
console.log('numero do ticket  ' + res2.data.pegaProtocolo)
        // const res3 = await axios.get(Conexao.api + 'BuscarResponsaveisEmailWEB.php? responsavel2=' + responsavel2);
        // setEmail(res3.data.Email);

        // console.log('email destino  ' + res3.data.Email)

        // const res = await axios.get('http://servidor.geocontrole.com/EmailSGI/EmailAberturaNC.php? email=' + res3.data.Email + '&nprocesso=' + res2.data.pegaProtocolo
        //     + '&setorOrigem2=' + setorX + '&descricao=' + descricaoproblema);

        // if (res.data.success === false) { }
        // else { }
    };


    return (<div>
        <Menu />
        <div style={{ width: '80%', marginTop: '10%', marginLeft: '10%', marginBottom: '10%' }}>
            <h1 style={{ textAlign: 'center' }}>Abertura de Ticket</h1>
            <div className="card">
                <div className="card-body">
                    <form>
                        <div className="form-group">
                            <label>Data de Envio</label>
                            <input type="date" className="form-control" value={dataEnvio} onChange={e => setDataEnvio(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Usuário de Login</label>
                            <input type="text" className="form-control" value={usuarioLogin} onChange={e => setUsuarioLogin(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input type="text" className="form-control" value={email} onChange={handleEmailChange} />
                            {emailError && <div className="error">{emailError}</div>}
                        </div>
                        <div className="form-group">
                            <label>Telefone</label>
                            <InputMask mask="(99) 99999-9999" value={telefone} onChange={e => setTelefone(e.target.value)}>
                                {(inputProps) => <input {...inputProps} type="text" className="form-control" />}
                            </InputMask>
                        </div>
                        <div className="form-group">
                            <label>Projeto</label>
                            <input type="text" className="form-control" value={projeto} onChange={e => setProjeto(e.target.value)} />
                        </div>
                        <div className="form-group">
                            <label>Itens enviados</label>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="notebookDesktop" onChange={e => setPc(e.target.checked)} />
                                <label className="form-check-label" htmlFor="notebookDesktop">
                                    Notebook / Desktop - Identificação:
                                </label>
                                <input type="text" className="form-control" placeholder="exemplo: GEOCONTROLE01" value={tag} onChange={e => setTag(e.target.value)} />
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="carregador" onChange={e => setCarregador(e.target.checked)} />
                                <label className="form-check-label" htmlFor="carregador">
                                    Carregador
                                </label>
                            </div>
                            <div className="form-check">
                                <input className="form-check-input" type="checkbox" id="outros" onChange={e => setOutros(e.target.checked)} />
                                <label className="form-check-label" htmlFor="outros">
                                    Outros
                                </label>
                            </div>
                            {outros && (
                                <div className="form-group">
                                    <input className="form-control" rows="3" value={detalhes} onChange={e => setDetalhes(e.target.value)}></input>
                                </div>
                            )}
                        </div>
                        <div className="form-group">
                            <label>Problema apresentado:</label>
                            <textarea className="form-control" rows="3" value={problemaApresentado} onChange={e => setProblemaApresentado(e.target.value)}></textarea>
                        </div>
                        <form onSubmit={handleSubmit}>
                            <button type="submit" className="btn btn-primary" onClick={(e) => { e.preventDefault(); handleSubmit(e); }} style={{ marginTop: '20px', float: 'right' }}>Enviar</button>
                        </form>
                    </form>
                </div>
            </div>
        </div>
    </div>
    );
}

